import { IUseContentPagePreviewProps } from 'components/Pages/Admin/shared/ItinerariesItemLanding/types';
import { parseLatLngFromString } from 'utils/maps';

import { getHandledPageName } from '../../../utils';
import * as types from './../../types';

type Props = types.AreaFormValues | (IUseContentPagePreviewProps & types.AreaFormValues);

export const handleFormValues = (formValues: Props) => {
  const { lat: latitude, lng: longitude } = parseLatLngFromString(formValues.coords);
  const handle = getHandledPageName(formValues);

  const res = {
    ...formValues,
    handle,
    latitude,
    longitude,
  };

  return res;
};
